import { render, staticRenderFns } from "./AnaliseHistorico.vue?vue&type=template&id=d2ad67ba&scoped=true&lang=pug"
import script from "./AnaliseHistorico.vue?vue&type=script&lang=js"
export * from "./AnaliseHistorico.vue?vue&type=script&lang=js"
import style0 from "./AnaliseHistorico.vue?vue&type=style&index=0&id=d2ad67ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2ad67ba",
  null
  
)

export default component.exports